<template>
  <div class="related-to-page">
    <ul>
      <li :class="{ active: isActive('/vikings/overview') }">
        <router-link to="/vikings/overview">Viking</router-link>
      </li>
      <li :class="{ active: isActive('/vikings/results') }">
        <router-link to="/vikings/results">Results</router-link>
      </li>
      <li :class="{ active: isActive('/vikings/maps') }">
        <router-link to="/vikings/maps">Map</router-link>
      </li>
      <li :class="{ active: isActive('/vikings/references') }">
        <router-link to="/vikings/references">References</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'VikingsNavigation',
  computed: {
    // Access the current route
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    // Determine if the route matches the current path
    isActive(path) {
      return this.currentRoute === path;
    },
  },
};
</script>